import { render, staticRenderFns } from "./FireManageNew.vue?vue&type=template&id=f735ad2e&scoped=true&"
import script from "./FireManageNew.vue?vue&type=script&lang=js&"
export * from "./FireManageNew.vue?vue&type=script&lang=js&"
import style0 from "./FireManageNew.vue?vue&type=style&index=0&id=f735ad2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f735ad2e",
  null
  
)

export default component.exports